import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

const ROW_ITEM_NEGATIVE_OFFSET = 26;
export const ILLUSTRATION_SIZE = {
  height: 182,
  width: 146,
};

const styles = createStyleSheet({
  wrapperExternal: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    alignItems: 'center',
  },
  wrapperInternal: {
    display: 'flex',
    flexDirection: 'column',
    padding: `41px 51px 55px ${51 - ROW_ITEM_NEGATIVE_OFFSET}px`,
    marginTop: 40,
    marginBottom: 50,
    background: COLORS.WHITE.DEFAULT,
    borderRadius: 12,
    boxShadow: '0px 16px 34px 0px rgba(103, 108, 131, 0.03)',
  },
  illustrationContainer: {
    position: 'absolute',
    zIndex: 0,
  },

  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${ROW_ITEM_NEGATIVE_OFFSET}px`,
  },
  returnButton: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    gap: 10,
    ...TYPOGRAPHY.BODY1,
    color: '#000000',
    padding: '0px 1px',
  },
  title: {
    ...TYPOGRAPHY.TITAN_L_SEMIBOLD,
    color: COLORS.BLACK.DEFAULT,
    marginTop: 25,
  },
  subtitle: {
    ...TYPOGRAPHY.H3,
    color: COLORS.TEXT.SECONDARY_DEFAULT,
    marginTop: 10,
  },

  bodyContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 24,
    width: 698 + ROW_ITEM_NEGATIVE_OFFSET,
    zIndex: 10,
  },
  microknowledge: {
    marginLeft: 24,
  },
  AddMkButton: {
    fontFamily: 'Source Sans Pro',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    color: COLORS.TEXT.DEFAULT,
    lineHeight: '17.6px',
  },
  bodyBottomContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 51,
  },

  footerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 46,
    gap: 31,
  },
  exitButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    height: 100,
    minHeight: 100,
  },
});

export default styles;
